const forms = [
  {
    name: "Delivery Note",
    className: "bg-white p-4 rounded-md p-8 w-[100%] mx-auto",
    options: [
      {
        name: "Sales Order",
        type: "select",
        form: {
          type: "text",
          name: "number",
          allowClear: true, 
          showSearch: true,
          filterOption: false,
          placeholder: "Select Sales Order",
          api: "get-pending-sales-orders",
          options: null,
          value: null,
          required: true,
        },
      },
      {
        name: "Customer",
        type: "selectandadd",
        path: "/app/customers/add",
        form: {
          name: "customer",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Customer",
          api: "get-all-customers",
          options: null,
          value: null,
          required: false,
        },
      },
      {
        name: "Number",
        type: "input",
        form: {
          type: "text",
          name: "number",
          placeholder: "Delivery Note number",
          class: "",
          value: "",
          required: false,
        },
      },
      {
        name: "Date",
        type: "date",
        form: {
          type: "text",
          name: "date",
          placeholder: "Delivery Note date",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Due Date",
        type: "due_date",
        form: {
          type: "text",
          name: "due_date",
          placeholder: "Delivery Note due date",
          class: "",
          value: "",
          required: false,
        },
      },
      {
        name: "Salesman",
        type: "selectandadd",
        path: "/app/salesman/add",
        form: {
          name: "salesman",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Salesman",
          api: "get-all-salesman",
          options: null,
          value: null,
          required: false,
        },
      },
      {
        name: "Status",
        type: "select",
        form: {
          name: "status",
          allowClear: false,
          placeholder: "Status",
          value: 1,
          options: [
            {
              value: 1,
              label: "Active",
            },
            {
              value: 0,
              label: "In-active",
            },
          ],
          required: false,
        },
      },
    ],
  },
];

export default forms;